import type { BDRSummary } from "@shared/types";
import { CheckCircle2, ChevronDown } from "lucide-react";

interface Props {
  bdr: BDRSummary;
  onChangeBdr?: () => void;
  dark?: boolean;
}

export function IdentityBanner({ bdr, onChangeBdr, dark = false }: Props) {
  if (dark) {
    return (
      <div className="backdrop-blur-2xl bg-white/[0.02] rounded-2xl border border-white/[0.05] p-4 mb-5 flex items-center gap-3 relative overflow-hidden">
        {/* Gradient left edge */}
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#05FAFC] to-[#7573F7]" />
        <CheckCircle2 className="text-[#05FAFC] shrink-0 ml-2" size={20} />
        <div className="flex-1 min-w-0">
          <div className="font-bold text-white">
            Submitting as {bdr.full_name}
          </div>
          <div className="text-sm text-white/40 truncate">
            {bdr.email} · on behalf of <span className="font-bold text-white/60">{bdr.vendor_name}</span>
          </div>
        </div>
        {onChangeBdr && (
          <button
            onClick={onChangeBdr}
            className="text-xs text-white/40 hover:text-white/70 transition-colors font-medium whitespace-nowrap px-3 py-1.5 rounded-lg hover:bg-white/[0.05]"
          >
            Not you? <ChevronDown size={12} className="inline" />
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="card p-4 mb-4 flex items-center gap-3 relative overflow-hidden">
      {/* Gradient left edge */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-brand-gradient" />
      <CheckCircle2 className="text-periwinkle shrink-0 ml-2" size={20} />
      <div className="flex-1 min-w-0">
        <div className="font-bold text-midnight">
          Submitting as {bdr.full_name}
        </div>
        <div className="text-sm text-grape truncate">
          {bdr.email} · on behalf of <span className="font-bold">{bdr.vendor_name}</span>
        </div>
      </div>
      {onChangeBdr && (
        <button onClick={onChangeBdr} className="btn-ghost text-xs whitespace-nowrap">
          Not you? <ChevronDown size={12} className="inline" />
        </button>
      )}
    </div>
  );
}
